export default "::ng-deep mat-dialog-container.mat-dialog-container {\n  max-height: none;\n}"